export const TICKET = {
    NEW: "00-0000"
};